import * as actionTypes from './actionTypes'
import { updateFieldWarning } from './FieldValidationAction'
import { getWarningDetail } from '../api/getEntrySummaryData'
import _ from 'lodash'
// FORM
export function initializeValuesBondInfo(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_BOND_INFO,
    payload
  }
}

export function initializeShipmentNotes(payload , notesLoaded){
  return {
      type : actionTypes.INITIALIZE_VALUES_NOTES,
      payload,
      notesLoaded
  }
}


export function initializeValuesImporter(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_IMPORTER,
    payload
  }
}

export function initializeCarrierCodeList(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_CARRIER_CODE,
    payload
  }
}

export function initializeValuesEntryType(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_ENTRY_TYPE,
    payload
  }
}
export function initializeValuesRecon(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_RECON,
    payload
  }
}

export function initializeValuesTransportation(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TRANSPORTATION,
    payload
  }
}

export function initializeValuesBOL(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_BOL,
    payload
  }
}

export function initializeValuesPSC(payload, pscShipmentId) {
  return {
    type: actionTypes.INITIALIZE_VALUES_PSC,
    payload,
    pscShipmentId
  }
}

export function initializeValuesDescriptionOfMerchandise(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE,
    payload
  }
}

export function initializeValuesPscChain(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_PSC_CHAIN,
    payload
  }

}

export function initializeValuesDeclarationSection(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_DECLARATION_SECTION,
    payload
  }
}

// VALIDATION
export function intializeWarnings(payload,allpropsaa) {
  const allpropsaaCopied = { ...(allpropsaa||{}), topLevelStateX:null};
  return {
    type: actionTypes.INITIALIZE_WARNINGS,
    payload,
    allpropsaa: allpropsaaCopied,
  }
}
export function initializeValuesServerWarnings(payload) {
  return {
    type: actionTypes.INITIALIZE_SERVER_WARNINGS,
    payload
  }
}


export function initializeValuesFieldValidation(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.INITIALIZE_VALUES_FIELD_VALIDATION,
      payload
    })
    payload.fields.length ? payload.fields.forEach(fieldItem => {
      if (fieldItem.ApplicableWarningCode) {
        getWarningDetail(fieldItem.ApplicableWarningCode).then(response => {
            if(_.get(response, 'data.eventMessage.warnings')){
              dispatch(updateFieldWarning({...fieldItem,...response.data.eventMessage.warnings[0]}, fieldItem.merchandiseId))
            }
          })
      }
    }) : dispatch({
      type: "RESET_FIELD_WARNINGS"
    })
  }
}

export function setErrorMessage(
  errorMessage
) {
  return {
    type: actionTypes.SET_ERROR_MESSAGE,
    errorMessage
  }
}

// PGA

export function initializeLaceyAct(pgaGuid, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_LACEY_ACT(pgaGuid),
    payload
  }
}

export function initializeLaceyActWithTemplates(pgaGuid, payload, templates) {
  return {
    type: actionTypes.INITIALIZE_VALUES_LACEY_ACT(pgaGuid),
    payload,
    templates
  }
}

export function initializeTargetPGA(targetPGA, pgaGuid, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TARGET_PGA(pgaGuid),
    targetPGA,
    pgaGuid,
    payload
  }
}

export function initializeTargetPGAWithTemplates(targetPGA, pgaGuid, payload, templates) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TARGET_PGA(pgaGuid),
    targetPGA,
    payload,
    pgaGuid,
    templates
  }
}

export function initializeTSCA(pgaGuid, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TSCA(pgaGuid),
    payload
  }
}

export function initializeTSCAWithTemplates(pgaGuid, payload, templates) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TSCA(pgaGuid),
    payload,
    templates
  }
}

export function initializeFDA(pgaGuid, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_FDA(pgaGuid),
    payload
  }
}

export function initializeFDAWithTemplates(pgaGuid, payload, templates) {
  return {
    type: actionTypes.INITIALIZE_VALUES_FDA(pgaGuid),
    payload,
    templates
  }
}



export function initializeNHTSA(pgaGuid, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_NHTSA(pgaGuid),
    payload
  }
}

export function initializeNHTSAWithTemplates(pgaGuid, payload, templates) {
  return {
    type: actionTypes.INITIALIZE_VALUES_NHTSA(pgaGuid),
    payload,
    templates
  }
}

// META
export function initializeDropDowns(payload) {
  return {
    type: actionTypes.INITIALIZE_DROPDOWNS,
    payload
  }
}

export function initializeShipId(payload) {
  return {
    type: actionTypes.INITIALIZE_SHIPID,
    payload
  }
}

export function setFormLoaded(formLoaded, shipmentId, userType, error = null) {
  return {
    type: actionTypes.FORM_LOADED,
    formLoaded,
    shipmentId,
    userType,
    error
  }
}

// FORM VALUES
export function setFormValues(
  penClicked,
  setINPUTID,
  newValue,
  fieldName,
  rbCounterID,
) {
  return {
    type: actionTypes.FORM_VALUES,
    penClicked,
    setINPUTID,
    newValue,
    fieldName,
    rbCounterID,
  }
}

export function setAnyFormValue(valueName, value) {
  return {
    type: actionTypes.SET_ANY_FORM_VALUES,
    valueName,
    value
  }
}
